import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'homeIndex',
    beforeEnter: (to, from, next) => {
      const token = localStorage.getItem('token')
      if (token) {
        next('/design')
      } else {
        next()
      }
    },
    component: () => import('../view/home/home.vue'),
  },
  // 作品设计（新）- 应用通过编号动态加载
  {
    path: '/design',
    name: 'design',
    component: () => import('../view/design/designHome.vue'),
    children: [
      {
        path: ':appNumber',
        name: 'designApp',
        component: () => import('../view/design/designHome.vue'),
      },
      {
        path: 'inspirationBoard',
        name: 'designInspirationBoard',
        component: () => import('../view/paint/inspirationBoard.vue'),
      },
    ]
  },
  // 2.0版本
  {
    path: '/imgPaint',
    name: 'imgPaint',
    redirect: '/imgPaint/subImgPaint',
    component: () => import('../view/paint/paintHome.vue'),
    children: [
      {
        path: 'subImgPaint',
        name: 'subImgPaint',
        component: () => import('../view/paint/imgPaint.vue'),
      },
      {
        path: 'txt2img',
        name: 'txt2img',
        component: () => import('../view/paint/txt2img.vue'),
      },
      {
        path: 'imgInImg',
        name: 'imgInImg',
        component: () => import('../view/paint/imgInImg.vue'),
      },
      {
        path: 'draw2img',
        name: 'draw2img',
        component: () => import('../view/paint/draw2img.vue'),
      },
      {
        path: 'imgAddColor',
        name: 'imgAddColor',
        component: () => import('../view/paint/imgAddColor.vue'),
      },
      {
        path: 'inspirationBoard',
        name: 'inspirationBoard',
        component: () => import('../view/paint/inspirationBoard.vue'),
      },
    ]
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
